import { render } from "./ImageOverlay.vue?vue&type=template&id=650e304e&scoped=true"
import script from "./ImageOverlay.vue?vue&type=script&lang=js"
export * from "./ImageOverlay.vue?vue&type=script&lang=js"

import "./ImageOverlay.vue?vue&type=style&index=0&id=650e304e&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650e304e"]])

export default __exports__